import { createEntityAdapter } from '@reduxjs/toolkit'
import { ParagraphAndImageAnnotation } from 'sierra-client/state/pdf-annotation/types'
import { PdfAnnotationImage, PdfAnnotationToken } from 'sierra-domain/api/author-v2'

export const userAnnotationAdapter = createEntityAdapter<ParagraphAndImageAnnotation>({
  sortComparer: (a, b) => a.id.localeCompare(b.id),
})
export const precomputedTokenAnnotationAdapter = createEntityAdapter<PdfAnnotationToken>()
export const precomputedImageAnnotationAdapter = createEntityAdapter<PdfAnnotationImage>()
